"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["Production"] = "production";
    Environment["Development"] = "development";
})(Environment || (exports.Environment = Environment = {}));
